module.exports = __webpack_public_path__ + "static/media/pl2.b5907096.png";